import { apiMap } from '@qm-activity/common/assets/ts/const';
import { get, post, postForm } from '@common/http';

// 任务列表
export const apiTaskList = () => {
    return get(`${apiMap.apiMa}/marathon/api/v1/task-list`);
};

// 完成任务
export const apiTaskFinish = (params: { task_id: string }) => {
    return post(`${apiMap.apiMa}/marathon/api/v1/task-finish`, params);
};

// 一键领取里程
export const apiOneClickReceive = (params: Record<string, never> = {}) => {
    return post(`${apiMap.apiMa}/marathon/api/v1/one-click-receive`, params);
};

// 跑道数据
export const apiIndex = (params: Record<string, any> = {}) => {
    return get(`${apiMap.apiMa}/marathon/api/v1/index`, params, { noUseJsb: true, });
};

// 中奖名单公示页面
export const apiPrizeList = () => {
    return get(`${apiMap.apiXs}/marathon/api/v1/winning-list`, {}, { noUseJsb: true, });
};

// 跑马灯
export const apiRollingTips = () => {
    return get(`${apiMap.apiMa}/marathon/api/v1/rolling-tips`, {}, { noUseJsb: true, });
};

// 我的奖品
export const apiMyAwards = () => {
    return get(`${apiMap.apiMa}/marathon/api/v1/my-prize`);
};

// 兑换
export const apiAdExchange = (params: any) => {
    return post(`${apiMap.apiMa}/marathon/api/v1/free-ad-exchange`, params);
};

// 助力 - 提交
export const apiSupport = (params: Record<string, any>) => {
    return post(`${apiMap.apiMa}/marathon/api/v1/friend-support/submit`, params);
};
// 助力 - 查询
export const apiSupportResult = () => {
    return get(`${apiMap.apiMa}/marathon/api/v1/friend-support/result`);
};

// 用户信息
export const apiUserInfo = () => {
    return get(`${apiMap.apiMa}/marathon/api/v1/user-info`, { op_type: '1', }, { noUseJsb: true, });
};

// 站点对应所有奖励
export const apiSitePrizes = () => {
    return get(`${apiMap.apiMa}/marathon/api/v1/my-site-prize`);
};
